import React from "react";

export const TabPanel = ({ title, tab, setTab, tabs, content }) => {
  return (
    <div className="mx-auto w-full gap-4">
      <div className="">
        <div className="relative flex md:justify-around z-40">
          {tabs?.map((el) => {
            return (
              <button
                key={el.id}
                onClick={() => setTab(el?.id)}
                className={`w-full md:w-fitvpx-2 md:px-4 flex flex-row flex-nowrap justify-center items-center gap-1 relative py-2`}
              >
                {el?.icon}
                <div className="tab-text-xl">{el?.text}</div>

                <div
                  className={` absolute -bottom-2 w-full h-2 bg-dark-pink shadow-md rounded-md backdrop-blur-md duration-300 mx-auto ${
                    tab === el?.id ? "opacity-100 z-30" : "opacity-0 z-10"
                  }`}
                ></div>
              </button>
            );
          })}
        </div>

        {/* <!-- tabs content --> */}
        <div className="w-full h-2 z-10 bg-white/30 shadow-md rounded-md backdrop-blur-md mb-2  mx-auto"></div>
      </div>
      {/* max-w-lg md:max-w-4xl */}
      <div className="flex flex-col relative">
        {content?.map((el) => (
          <div
            className={
              "py-4 transition-opacity duration-300 absolute w-full h-full " +
              (el.id === tab ? "opacity-100  z-30" : "opacity-0  z-10")
            }
          >
            {el.child}
          </div>
        ))}
      </div>
    </div>
  );
};
